import { render, staticRenderFns } from "./assignEmployeesDialog.vue?vue&type=template&id=35f542dd"
import script from "./assignEmployeesDialog.vue?vue&type=script&lang=ts"
export * from "./assignEmployeesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports